import { LinkProps, PaletteColorOptions, createTheme } from "@mui/material";
import { CustomLink } from "../components/CustomLink";

const primary: PaletteColorOptions = {
    main: "#f98c19", //500
    light: "#fdb857", //300
    dark: "#ea701a", //800
    contrastText: "#fef3e1" //50
}

const info: PaletteColorOptions = {
    main: "#1996ff",
    light: "#61b6ff",
    dark: "#2163d1",
    contrastText: "#bbdeff"
}

const error: PaletteColorOptions = {
    main: "#cb5555",
    light: "#d69799",
    dark: "#9f3331",
    contrastText: "#efcbd0"
}

const secondary: PaletteColorOptions = {
    main: "#2db415",
    light: "#9fd995",
    dark: "#008200",
    contrastText: "#e7f6e5"
}

const success: PaletteColorOptions = {
    main: "#8eb849",
    light: "#cfe2a3",
    dark: "#648e29",
    contrastText: "#e2eec7"
}

export const theme = createTheme({
    palette: {
        primary,
        secondary,
        error,
        // warning,
        info,
        success
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: primary.contrastText
                }
            }
        },
        MuiLink: {
            defaultProps: {
                component: CustomLink,
            } as LinkProps,
        },
        MuiButtonBase: {
            defaultProps: {
                LinkComponent: CustomLink,
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 24,
                    textTransform: "none"
                },
            },
        },
    },
    typography: {
        fontFamily: "Barlow"
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1300,
            xl: 1500
        }
    }
})